import { useLocation } from 'react-router-dom';
import { RouteHistoryEntry } from '../../support/slices/uiSlice';
import React from 'react';

const styles = {
  itemButton: [
    'cursor-pointer',
    'text-gray-50',
    'capitalize',
    'mx-2',
    'my-1',
    'px-4',
    'py-1',
    'hover:bg-gray-10',
    'rounded-lg',
    'hover:text-gray-90',
    'font-semibold',
    'leading-5',
    'text-xs',
  ].join(' '),
  selectedRouteButton: [
    'border-l-4',
    'bg-gray-10',
    'border-med-blue-30',
    'rounded-l-sm',
    'hover:border-med-blue-40',
    'text-gray-90',
    'rounded-l-sm',
    'pl-3',
  ].join(' '),
};

interface Props {
  handleClick: (route: string) => void;
  currentRoute: string;
  navItem: RouteHistoryEntry;
}

const StbSideNavigationItem = ({
  handleClick,
  currentRoute,
  navItem,
}: Props) => {
  return (
    <div
      className={`${styles.itemButton} ${navItem.route.endsWith(currentRoute) ? styles.selectedRouteButton : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        handleClick(navItem.route);
      }}
    >
      {navItem.title ??
        navItem.params?.section ??
        navItem.route.replace('/', ' ')}
    </div>
  );
};

export default StbSideNavigationItem;
